import {
    QuestionCircleOutlined,
    NotificationOutlined,
  } from '@ant-design/icons';
  import { APP_PREFIX_PATH } from 'configs/AppConfig'
 
  import filesIcono from '../../menus/icons/filesIcono.js'
  import encuestasIcono from '../../menus/icons/encuestasIcono.js'
  import chatIcon from './../icons/chatIcon.js'
  import difusionIcono from './../icons/difusionIcono.js'
  import tarea from '../../menus/icons/tarea.js'


let ModuloComunicacion = [
  {
    key: "comunicacion",
    path: `${APP_PREFIX_PATH}/`,
    title: "sidenav.comunicacion",
    icon: QuestionCircleOutlined,
    breadcrumb: true,
    permission:['Create:avisos','Create:archivos','Create:examen','Create:encuestas','Create:gruposDifusion'],
    submenu: [
      {
        key: "avisos",
        path: `${APP_PREFIX_PATH}/avisos`,
        title: "sidenav.avisos",
        icon: NotificationOutlined,
        breadcrumb: true,
        permission:['Create:avisos'],
        submenu: [],
      },
      {
        key: "mensajes",
        path: `${APP_PREFIX_PATH}/mensajes`,
        title: "sidenav.mensajes",
        icon: chatIcon,
        breadcrumb: true,
        permission:['Read:messages'],
        submenu: [],
      },
      {
        key: "archivos",
        path: `${APP_PREFIX_PATH}/archivos`,
        title: "sidenav.archivos",
        icon: filesIcono,
        breadcrumb: true,
        permission:['Create:archivos'],
        submenu: [],
      },
      {
        key: "Examenes",
        path: `${APP_PREFIX_PATH}/examen`,
        title: "sidenav.examenes",
        icon: tarea,
        breadcrumb: true,
        permission:['Create:examen'],
        submenu: [],
      },
      {
        key: "encuestas",
        path: `${APP_PREFIX_PATH}/encuestas/list`,
        title: "sidenav.encuestas",
        icon: encuestasIcono,
        breadcrumb: true,
        permission:['Create:encuestas'],
        submenu: [],
      },
      {
        key: "grupos-difusion-",
        path: `${APP_PREFIX_PATH}/difusion/list`,
        title: "sidenav.gruposdifusion",
        icon: difusionIcono,
        breadcrumb: true,
        permission:['Create:gruposDifusion'],
        submenu: [],
      },
    ],
  },
];

export default ModuloComunicacion;
